import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthenticationActions, AuthenticationApiActions } from '../../store/authentication/authentication.actions';
import { UserSignUp } from '../../models/authentication/user-sign-up.model';
import { mergeMap, Observable, of } from 'rxjs';
import { Actions, ofType } from '@ngrx/effects';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationFacadeService {
    constructor(
        private store: Store,
        private actions$: Actions
    ) {}

    signUp(userData: UserSignUp): Observable<string> {
        this.store.dispatch(AuthenticationApiActions.signUp({ userData }));
        return this.actions$.pipe(
            ofType(AuthenticationActions.signUpSuccess, AuthenticationActions.signUpFailure),
            mergeMap((action) => {
                if (action.type === AuthenticationActions.signUpFailure.type) {
                    throw action.error;
                } else {
                    return of('ok');
                }
            })
        );
    }
}
